<template>
  <div class="recommend">
    <div class="top" style="position:relative;">
      <div class="head"></div>
      <div class="open_recommend">
        <img src="../../common/images/tuijian_bg.png" @click="addInfo" />
        <img
          v-show="distinguish === 'WX'"
          src="../../common/images/zaigoubg.png"
          @click="buyAgain"
        />
      </div>
      <div class="total">
        <div class="tongji">
          <div class="mine">
            <span class="span">
              <span style="font-size: 25px;">{{ tuijian }}</span
              >人
            </span>
            <span>我的推荐</span>
            <div class="line"></div>
          </div>
          <div class="mine" @click="tojifen">
            <span class="span">
              <span style="font-size: 25px;">{{ jifen }}</span
              >分
            </span>
            <span>我的积分</span>
            <div class="line"></div>
          </div>
          <div class="mine">
            <span class="span">
              <span style="font-size: 25px;">{{ yongjin }}</span
              >元
            </span>
            <span>我的佣金</span>
          </div>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="title">
        <div class="recommend_record"></div>
        <span>我的推荐记录</span>
      </div>
      <div class="content">
        <div class="title_check">
          <ul>
            <li @click="checkedBtn(0)">
              <button
                :class="btnIndex === 0 ? 'checked' : ''"
                :disabled="!handleDisable"
              >
                已推荐
              </button>
            </li>
            <li @click="checkedBtn(1)">
              <button
                :class="btnIndex === 1 ? 'checked' : ''"
                :disabled="!handleDisable"
              >
                已到访
              </button>
            </li>

            <li @click="checkedBtn(3)">
              <button
                :class="btnIndex === 3 ? 'checked' : ''"
                :disabled="!handleDisable"
              >
                已认购
              </button>
            </li>
            <li @click="checkedBtn(2)">
              <button
                :class="btnIndex === 2 ? 'checked' : ''"
                :disabled="!handleDisable"
              >
                已签约
              </button>
            </li>
            <li @click="checkedBtn(4)">
              <button
                :class="btnIndex === 4 ? 'checked' : ''"
                :disabled="!handleDisable"
              >
                已失效
              </button>
            </li>
          </ul>
        </div>
        <div class="tips" v-if="btnIndex === 2 || btnIndex === 3">
          <span class="bgl"></span>
          <span>我们的成交是以签约为准</span>
          <span class="bgr"></span>
        </div>
        <div class="list" v-if="recommend_list.length > 0 ? true : false">
          <van-list
            v-model="loading"
            :finished="finished"
            finished-text="没有更多了"
            offset="20"
            @load="onLoadMore"
            :immediate-check="false"
          >
            <van-cell>
              <div class="table-head">
                <div class="head" style="width:18%">序号</div>
                <div class="head">被推荐人</div>
                <div class="head" style="margin: 0 10px 0 0">推荐日期</div>
                <div
                  class="head"
                  v-show="btnIndex === 2 || btnIndex === 3"
                  style="margin: 0 10px 0 0"
                >
                  {{ btnIndex === 2 ? "签约" : "认购" }}日期
                </div>
                <div
                  class="head"
                  v-show="btnIndex === 2 || btnIndex === 3 || btnIndex === 0"
                >
                  推荐项目
                </div>
                <div class="head" v-show="btnIndex === 1" style="width:18%">
                  进展
                </div>
                <!-- <div class="head" v-show="btnIndex === 4">
                  操作
                </div> -->
              </div>
            </van-cell>
            <div style="height:calc(100% - 44px);overflow: scroll;">
              <van-cell
                :class="{ fail_tips: item.ifMatch === false }"
                v-for="(item, index) in recommend_list"
                :key="item.recommend.id"
              >
                <div class="table-main">
                  <div class="head" style="width:18%">{{ index + 1 }}</div>
                  <div class="head">
                    {{ item.recommend.presentee }}
                  </div>
                  <div
                    :class="{
                      head: true,
                      date: btnIndex === 2 || btnIndex === 3 ? true : false,
                    }"
                    style="margin: 0 10px 0 0"
                  >
                    {{ formatterDate(item.recommend.createDate) }}
                  </div>
                  <div
                    :class="{
                      head: true,
                      date: btnIndex === 2 || btnIndex === 3 ? true : false,
                    }"
                    v-show="btnIndex === 2 || btnIndex === 3"
                    style="margin: 0 10px 0 0"
                  >
                    {{
                      btnIndex === 2
                        ? formatterDate(item.recommend.signDate)
                        : formatterDate(item.recommend.subscribeTime)
                    }}
                  </div>
                  <div
                    class="head el"
                    v-show="btnIndex === 2 || btnIndex === 3 || btnIndex === 0"
                  >
                    {{ item.recommend.projectName }}
                  </div>
                  <div class="head" v-show="btnIndex === 1" style="width:18%">
                    {{ initStadus(item.recommend.status) }}
                  </div>
                  <!-- <div
                    class="head one_key"
                    v-show="btnIndex === 4"
                    @click="oneKey(item.recommend.id)"
                  >
                    一键推荐
                  </div> -->
                </div>
              </van-cell>
              <!-- </van-list> -->
            </div>
          </van-list>
        </div>
        <div class="nodata" v-else>
          <nodata />
        </div>
      </div>
    </div>
    <div class="rule">
      <span @click="toggleRule">《推荐须知》</span>
    </div>
    <div class="renzheng">
      <van-popup
        v-model="showPopup"
        :close-on-click-overlay="false"
        :style="{
          height: '354px',
          width: '270px',
          borderRadius: '16px',
        }"
      >
        <div class="content">
          <img src="../../common/images/renzheng.png" alt="" />
          <div class="wz">
            <p>您还未认证房屋</p>
            <p>认证后解锁更多精彩</p>
          </div>
        </div>
        <div class="foot">
          <button @click="toJointCertification">合资认证</button>
          <!-- <button @click="cancle">取消</button> -->

          <button @click="toCertification">去认证</button>
        </div>
      </van-popup>
    </div>
    <div class="feirenzheng">
      <van-popup
        v-model="showId"
        :close-on-click-overlay="false"
        :style="{ height: '354px', width: '270px', borderRadius: '16px' }"
      >
        <div class="content">
          <img src="../../common/images/meirenzheng.png" alt="" />
          <div class="wz">
            <p>当前身份无法访问应用~</p>
            <p>您可以前往我的房屋修改默认房屋</p>
            <p>或进行业主认证</p>
          </div>
        </div>
        <div class="foot">
          <button class="sure" @click="cancle">确认</button>
        </div>
      </van-popup>
    </div>
    <!-- loading -->
    <loading :show="loadingStatus"></loading>
  </div>
</template>
<script
  type="text/javascript"
  src="https://res.wx.qq.com/open/js/jweixin-1.3.2.js"
></script>
<script>
import nodata from "@/components/nodata";
import loading from "@/components/loading";
import { List, Popup, Toast } from "vant";

export default {
  components: { nodata, "van-list": List, "van-popup": Popup, loading },
  data() {
    return {
      loadingStatus: false,
      handleDisable: true,
      showPopup: false,
      showId: false,
      type: "wx",
      tuijian: "0",
      jifen: "0",
      yongjin: "0",
      load: false,
      finished: true,
      recommend_list: [],
      btnIndex: 0,
      loading: false,
      finished: false,
      load_more: false, // 是否加载更多
      nowpage: 1, // 当前页数
      distinguish: "APP",
    };
  },
  created() {
    document.title = "我要推荐";

    this.checkPermission();
    this.type = this.$route.query.type ? this.$route.query.type : "wx";

    this.getData(this.type);
    this.getRecommendList();
  },

  methods: {
    // 格式话时间
    formatterDate(date) {
      return (date && date.split(" ")[0].replace(/[-]/g, "/")) || "";
    },
    // 将老状态码转为新状态码
    oldStatusToNewStatus(old) {
      let map = {
        "0": "1,2,3",
        "1": 4,
        "3": 5,
        "2": 6,
        "4": 7,
      };
      return map[`${old}`] || "";
    },
    // 判断是否已经认证
    checkPermission() {
      if (this.getUrlParams().from && this.getUrlParams().from.includes("wx")) {
        this.distinguish = "WX";
      }
      return new Promise((resolve, reject) => {
        if (this.distinguish === "WX") {
          this.$api.userlist().then((res) => {
            if (!res.body.length) {
              this.showPopup = true;
              reject();
            } else {
              this.$api.getUserIdentity().then((res) => {
                if (res.body != "1" && res.body != "2") {
                  this.showId = true;
                } else {
                  resolve(true);
                }
              });
            }
          });
        }
      });
    },
    //判断是否为微信环境
    isweixin() {
      const ua = window.navigator.userAgent.toLowerCase();
      if (ua.match(/MicroMessenger/i) === "micromessenger") {
        return true;
      } else {
        return false;
      }
    },
    //再购
    async buyAgain() {
      let isok = await this.checkPermission();
      isok &&
        this.$router.push({
          name: "recommendInfo",
          params: {
            buyAgain: true,
          },
          query: { type: this.type },
        });
    },
    //格式化状态
    initStadus(v) {
      if ([1, 2, 3, 4].includes(v)) {
        return "已推荐";
      } else if (v == 4) {
        return "已到访";
      }
    },
    //一键推荐
    oneKey(id) {
      Toast("很抱歉该功能暂未开放！");
      return;
      // this.$router.push({
      //   name: "recommendInfo",
      //   params: {
      //     id,
      //   },
      //   query: { type: this.type },
      // });
    },
    // 下拉加载更多
    onLoadMore() {
      if (!this.finished) {
        // 是否还有下一页
        this.nowpage = Number(this.nowpage) + 1;
        this.loading = true;
        this.getRecommendList();
      }
    },
    //取消认证
    cancle() {
      wx.miniProgram.navigateBack();
    },
    // 合资认证
    toJointCertification() {
      this.showPopup = false;
      wx.miniProgram.navigateTo({
        url: "/pages/packageAuthor/pages/appeal/index",
      });
    },
    //业主认证
    toCertification() {
      this.showPopup = false;
      wx.miniProgram.navigateTo({
        url: "/pages/packageAuthor/pages/house-bind/index?from=LDX",
      });
    },

    //切换进度按钮
    checkedBtn(e) {
      this.handleDisable = false;
      this.recommend_list = [];
      this.btnIndex = e;
      this.nowpage = 1;
      this.getRecommendList();
    },
    //积分页面
    async tojifen() {
      let isok = await this.checkPermission();
      isok &&
        wx.miniProgram.navigateTo({
          url: "/newhope/pages/integral/integralDetail/index",
        });
    },
    // 滚动到底事件
    onBottom() {
      // console.log('bottom')
    },
    async addInfo() {
      let isok = await this.checkPermission();
      isok &&
        this.$router.push({
          path: "/recommendInfo",
          query: { type: this.type },
        });
    },
    // 获取推荐头信息
    getData(type) {
      this.$api.getRecommendInfo({ type }).then((res) => {
        if (res.code === "0000") {
          let val = res.body;
          this.tuijian = val.recommendNum;
          this.jifen = val.score;
          this.yongjin = val.amount;
        }
      });
    },
    // 获取推荐列表
    getRecommendList() {
      let params = {
        urlFlag: this.distinguish,
        current: this.nowpage,
        size: 10,
        statuses: this.oldStatusToNewStatus(this.btnIndex),
        requestEntry: 4,
      };

      this.$api
        .getRecommendList(params)
        .then((res) => {
          res.body.records.forEach((item) => {
            this.recommend_list.push(item);
          });
          this.handleDisable = true;
          this.loadingStatus = false;

          if (this.nowpage >= res.body.pages) {
            this.finished = true;
            this.loading = false;
          } else {
            this.loading = false;
            this.finished = false;
          }
        })
        .catch((res) => {
          this.loadingStatus = false;
          this.handleDisable = true;
        });
      // this.$api.getRecommendList({ type }).then((res) => {
      //   if (res.code === '0000') {
      //     this.recommend_list = res.body;
      //   }
      // });
    },
    // 获取url参数
    getUrlParams() {
      let url = window.location.href.split("?")[1];
      let obj = {};
      if (!url) {
        return obj;
      }
      if (url.indexOf("&") > -1) {
        url = url.split("&");
        for (let i = 0; i < url.length; i++) {
          let arr = url[i].split("=");
          obj[arr[0]] = arr[1];
        }
      } else {
        url = url.split("=");
        obj[url[0]] = url[1];
      }

      return obj;
    },
    // 跳转协议详情
    toggleRule() {
      this.$router.push({ name: "agreement" });
    },
  },
};
</script>

<style lang="scss" scoped>
.recommend {
  .fail_tips {
    background: url("../../common/images/recommend/fail_status.png") no-repeat;
    background-size: 68px 50px;
    background-position: right 20px top 14px;
  }
  display: flex;
  flex-direction: column;
  position: relative;
  // height: 100vh !important;
  .top {
    height: 420px;
    .head {
      height: 184px;
      overflow: hidden;
      width: 100%;
      background-image: url("../../common/images/recommend/recommend_bg.png");
      background-size: 100% 100%;
      // .back {
      //   margin-top: 110px;
      //   display: flex;
      //   align-items: center;
      //   color: #fff;
      //   font-size: 32px;
      //   justify-content: flex-start;
      //   .back-jiantou {
      //     width: 18px;
      //     height: 28px;
      //     margin-left: 26px;
      //     margin-right: 28px;
      //     background-image: url("../../common/images/recommend/back.png");
      //     background-size: 100% 100%;
      //   }
      // }
    }
    .open_recommend {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 150px;
      margin: auto;
      width: 96%;
      height: 202px;
      z-index: 10;
      display: flex;
      justify-content: space-between;
      // background-image: url('../../common/images/recommend/recommend_logo.png');
      // background-size: 100% 100%;
    }
    .total {
      background: #f7f7f7;
      height: 236px;
      width: 100%;
      overflow: hidden;
      .tongji {
        height: 110px;
        width: 100%;
        margin-top: 88px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .span {
          color: #05442f;
          margin-bottom: 12px;
        }
        .mine {
          width: 33%;
          height: 100%;
          position: relative;
          color: #999999;
          font-size: 28px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          .line {
            height: 68px;
            width: 2px;
            background: #d8d8d8;
            position: absolute;
            right: -2px;
            top: 0;
            bottom: 0;
            margin: auto;
          }
        }
      }
    }
  }
  .main {
    flex: 1;
    width: 690px;
    margin: 30px auto;
    // height: calc(100% - 596px);
    border: 1px solid #f2f2f2;
    border-radius: 12px;
    display: flex;
    flex-direction: column;
    .title {
      height: 95px;
      color: #195541;
      font-size: 32px;
      border: 12px 12px 0px 0px;
      background: #f4f8f7;
      display: flex;
      align-items: center;
      justify-content: center;
      .recommend_record {
        width: 44px;
        height: 44px;
        margin-right: 16px;
        background-image: url("../../common/images/recommend/recommend_record_icon.png");
        background-size: 100% 100%;
      }
    }
    .content {
      height: calc(100% - 95px);
      width: 100%;
      .title_check {
        padding: 30px;
        ul {
          display: flex;
          justify-content: space-between;
          button {
            width: 116px;
            height: 64px;
            background: #ffffff;
            border-radius: 16px;
            border: 1px solid #e6e6e6;
            display: inline-flex;
            justify-content: center;
            align-items: center;
            color: #666666;
            font-size: 28px;
            padding: 0;
          }
          .checked {
            background: #0d9869;
            color: #ffffff;
          }
        }
      }
      .tips {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;

        span {
          font-size: 24px;
          margin: 0 4px;
          color: #409377;
        }
        .bgl {
          width: 120px;
          height: 1px;
          background-image: linear-gradient(to left, #0d9869, #ffffff);
        }
        .bgr {
          width: 120px;
          height: 1px;
          background-image: linear-gradient(to right, #0d9869, #ffffff);
        }
      }
      .nodata {
        width: 100%;
        height: 100%;
      }
      .list {
        height: 100%;
        color: #333333;
        font-size: 24px;
        .table-head {
          display: flex;
          height: 44px;
          color: #999999;
          align-items: center;
          justify-content: space-between;
          .head {
            height: 100%;
            width: 221px;
            text-align: center;
          }
        }
        .table-main {
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: space-between;
          height: 100%;
          overflow: hidden;
          .el {
            overflow: hidden;
            white-space: nowrap;
            text-overflow: ellipsis;
          }
          .date {
            font-size: 26px;
          }
          .head {
            height: 100%;
            width: 221px;
            text-align: center;
          }
        }
      }
    }
  }
  .rule {
    background-color: #fff;
    position: fixed;
    bottom: 0;
    height: 100px;
    padding: 30px;
    color: rgba(13, 152, 105, 1);
    box-sizing: border-box;
    width: 100%;
  }
  .renzheng {
    .content {
      display: inline-flex;
      height: 80%;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      padding: 20px 0;
      border-bottom: 1px solid #cccccc;
      .wz {
        height: 76px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        p {
          font-size: 28px;
          color: #666666;
        }
      }

      img {
        width: 60%;
        height: auto;
        background: #ffffff;
        border-radius: 16px;
      }
    }
    .foot {
      height: 20%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding: 0 20px;
      button {
        width: 200px;
        height: 76px;
        border-radius: 38px;
        border: 1px solid #008548;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        color: #008548;
        background-color: #fff;
        &:nth-child(2) {
          color: #ffffff;
          background: #008548;
        }
      }
    }
  }
  .feirenzheng {
    .content {
      width: 100%;
      display: inline-flex;
      height: 80%;
      flex-direction: column;
      justify-content: space-around;
      align-items: center;
      padding-top: 40px;
      .wz {
        height: 120px;
        display: inline-flex;
        flex-direction: column;
        align-items: center;
        justify-content: space-between;
        p {
          font-size: 28px;
          color: #666666;
        }
      }

      img {
        width: 60%;
        height: auto;
        background: #ffffff;
        border-radius: 16px;
      }
    }
    .foot {
      height: 20%;
      display: flex;
      align-items: center;
      justify-content: space-around;
      padding-bottom: 20px;
      .sure {
        color: #ffffff;
        width: 450px;
        height: 76px;
        background: #008548;
        border-radius: 38px;
        border: none;
      }
    }
  }
  .one_key {
    color: #0d9869;
  }
}
</style>
